import { createTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import { darkPalette, lightPalette } from './colors';
import { components } from './components';
import { typography } from './typography';

export type ResolvedMode = 'light' | 'dark';

const cache = new Map<ResolvedMode, Theme>();

export function getTheme(mode: ResolvedMode): Theme {
  const cached = cache.get(mode);
  if (cached) return cached;

  const theme = createTheme({
    palette: mode === 'dark' ? darkPalette : lightPalette,
    shape: { borderRadius: 12 },
    typography,
    components,
  });

  cache.set(mode, theme);
  return theme;
}
